var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('content-editor',{attrs:{"permission":"branch","fields":_vm.fields,"endpoint":"branch","module":"branch"}})}
var staticRenderFns = []

export { render, staticRenderFns }